// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Award from "../domain/types/Award.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as RnrRouteManager from "../routing/RnrRouteManager.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as RnrAwardDetailModal from "./RnrModalScreens/RnrAwardDetailModal.bs.js";
import * as LinkComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/external-link/LinkComponent.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function getAwardCard(title, date) {
  return React.createElement("div", {
              className: "history-component-award__text-section"
            }, React.createElement("div", {
                  className: "history-component-award__card-title"
                }, title), React.createElement("div", {
                  className: "history-component-award__card-date"
                }, date));
}

function getAwardSection(award, content) {
  if (typeof award === "number") {
    return null;
  }
  switch (award.TAG | 0) {
    case /* Fuel */0 :
        var award$1 = award._0;
        return getAwardCard(Curry._1(content.getFuelAwardCardTitle, String(award$1.fuelQuantity)), DateTime$Catalyst.toString("DD MMM YYYY", award$1.awardedAt));
    case /* Premiumness */1 :
        var award$2 = award._0;
        return getAwardCard(Curry._1(content.getPremiumnessAwardCardTitle, String(award$2.acceptAdvantage)), DateTime$Catalyst.toString("DD MMM YYYY", award$2.awardedAt));
    case /* RewardMultiplier */2 :
        var award$3 = award._0;
        return getAwardCard(Curry._1(content.getRewardMultiplierAwardCardTitle, award$3.multiplier.toString() + "X"), DateTime$Catalyst.toString("DD MMM YYYY", award$3.awardedAt));
    case /* NoAward */3 :
        return getAwardCard(content.noAward.cardTitle, DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt));
    case /* Monetary */4 :
        var award$4 = award._0;
        return getAwardCard(Curry._1(content.getMonetaryAwardCardTitle, String(award$4.amount)), DateTime$Catalyst.toString("DD MMM YYYY", award$4.awardedAt));
    case /* Insurance */5 :
        return getAwardCard(content.insuranceAward.cardTitle, DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt));
    case /* DistributionCeremony */6 :
        return getAwardCard(content.distributionCeremonyAward.cardTitle, DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt));
    case /* Final */7 :
        return getAwardCard(content.finalAward.cardTitle, DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt));
    case /* Coupon */8 :
        var award$5 = award._0;
        return getAwardCard(award$5.coupon_scheme.summary, DateTime$Catalyst.toString(undefined, award$5.awardedAt));
    
  }
}

function displayMilestone(milestone, content, cardPosition) {
  return React.createElement("div", {
              className: "history-component-award__card-container",
              onClick: (function (param) {
                  var award = milestone.award;
                  var tmp;
                  tmp = typeof award === "number" ? "" : (
                      award.TAG === /* Coupon */8 ? DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt) : DateTime$Catalyst.toString("DD MMM YYYY", award._0.awardedAt)
                    );
                  return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.level_gifts_card_clicked, undefined, undefined, Award.toString(milestone.award), tmp, cardPosition, undefined, undefined);
                })
            }, React.createElement("div", {
                  className: "history-component-award__milestone-badge-section u-flex__col"
                }, React.createElement("img", {
                      className: "history-component-award__milestone-badge",
                      src: milestone.milestoneBadge
                    })), getAwardSection(milestone.award, content));
}

function getView(viewModel, content, showModal, milestone) {
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", undefined, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, claimedMilestone) {
                        return React.createElement("div", undefined, React.createElement(LinkComponent$Catalyst.make, {
                                        href: RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                                              TAG: /* AwardHistory */3,
                                              _0: rnrParams.uuid,
                                              _1: claimedMilestone.milestoneName
                                            }),
                                        children: displayMilestone(claimedMilestone, content, index + 1 | 0),
                                        key: claimedMilestone.milestoneName
                                      }));
                      }), viewModel.milestoneDetails.claimedMilestones)), showModal ? React.createElement(RnrAwardDetailModal.make, {
                    milestone: milestone,
                    viewModel: viewModel,
                    content: content,
                    checkavailability: false
                  }) : null);
}

var AwardHistoryViewMapper = {
  getAwardCard: getAwardCard,
  getAwardSection: getAwardSection,
  displayMilestone: displayMilestone,
  getView: getView
};

export {
  AwardHistoryViewMapper ,
  
}
/* react Not a pure module */
